import { render, staticRenderFns } from "./IpBlocking.vue?vue&type=template&id=4f904334&scoped=true"
import script from "./IpBlocking.vue?vue&type=script&lang=js"
export * from "./IpBlocking.vue?vue&type=script&lang=js"
import style0 from "./IpBlocking.vue?vue&type=style&index=0&id=4f904334&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f904334",
  null
  
)

export default component.exports